module.exports = __webpack_public_path__ + "img/wecode.f0a67d0c.png";